import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(static)/layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/banner/index.tsx");
